<div class="container-box">
  <app-table-header tableTitle="Gestione menù BI" (btnUpdateClick)="loadMenuBiConfig()">
    <app-button-new-menu-bi action-button></app-button-new-menu-bi>
  </app-table-header>
  <div class="table-container">
    <ng2-smart-table
      id="menuBiConfigTable"
      class="table-content"
      [settings]="settings"
      [source]="source"
    ></ng2-smart-table>
  </div>
</div>
